import React, {useState} from 'react'
import styled from "styled-components"
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

// Storage can throw (private mode, blocked site data) — the tip must still work,
// at worst showing again next lesson.
const safeGetStorage = (key) => {
    try { return localStorage.getItem(key); } catch (e) { return null; }
};
const safeSetStorage = (key, value) => {
    try { localStorage.setItem(key, value); } catch (e) { /* ignored */ }
};

const TipCard = styled.div`
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 60;
    width: min(440px, calc(100% - 32px));
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 10px;
    background: #ffffff;
    color: #222222;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.35);
    font-size: 14px;
    line-height: 1.4;
`

const TipIcon = styled.span`
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #5562C0;
    color: #ffffff;
`

const TipText = styled.p`
    flex: 1 1 auto;
    margin: 0;
`

const TipButton = styled.button`
    flex: 0 0 auto;
    align-self: center;
    border: 0;
    border-radius: 6px;
    padding: 6px 12px;
    background: #5562C0;
    color: #ffffff;
    font-weight: 600;
    cursor: pointer;
`

/**
 * One-time explanation of the pin control. Pinning is otherwise easy to miss, and a
 * teacher has no way to know their pin locks every participant's view.
 */
const PinTip = ({show = false, moderator = false}) => {
    const storageKey = `muze_pin_tip_dismissed_${moderator ? 'teacher' : 'student'}`
    const [dismissed, setDismissed] = useState(() => safeGetStorage(storageKey) === '1')

    if (!show || dismissed) {
        return null
    }

    const dismiss = () => {
        safeSetStorage(storageKey, '1')
        setDismissed(true)
    }

    return (
        <TipCard role="status" data-testid="pin-tip">
            <TipIcon><FontAwesomeIcon icon={solid('thumbtack')} fixedWidth /></TipIcon>
            <TipText>
                <strong>Tip:</strong>{' '}
                {moderator
                    ? 'click the pin on any video to make it big. Your pin shows that video big for everyone in the lesson.'
                    : 'click the pin on any video to make it big on your screen.'}
            </TipText>
            <TipButton type="button" onClick={dismiss}>Got it</TipButton>
        </TipCard>
    )
}

export default PinTip
